import {useState} from "react";
import {
    Box, Button, ButtonGroup, Card, CardContent, Checkbox,
    FormControl, FormControlLabel, FormGroup,
    IconButton,
    InputLabel,
    MenuItem,
    Modal,
    OutlinedInput,
    Select,
    TextField, Tooltip,
    Typography
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import InfoIcon from '@mui/icons-material/Info';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PropTypes from "prop-types";
import {DateTimePicker, TimePicker} from "@mui/lab";
import LoadingBackdrop from "../../../components/LoadingBackdrop";
import {dateRangesOverlap, hoursOfDayOverlap, swapStartAndEnd} from "../../../utils/basicUtilities";

const modalStyle = {
    position: 'absolute',
    top: '25%',
    left: '50%',
    transform: 'translate(-50%, -25%)',
    // width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

/**
 * Component for managing suppression lists
 * @param props
 * @constructor
 */
export default function TimesOfDaySelector(props) {
    // const defaultValues = {
    //     startDate: new Date(Date.now()),
    //     endDate: new Date(Date.now() + 10000000),
    //     days: ["mon","tues","wed","thurs","fri","sat","sun"]
    // };
    // defaultValues.startDate.setFullYear(1,1,1);
    // defaultValues.endDate.setFullYear(1,1,1);
    // swapStartAndEnd(defaultValues);

    const schedules = props.schedules ? props.schedules : [];
    const scheduleElements = [];
    const dtFormat = {hour: '2-digit', minute: '2-digit' }
    for (let i = 0; i < schedules.length; i += 1) {
        const indexCnt = i;
        scheduleElements.push(
            <span style={{"display": "flex"}} key={`schedule${i}`}>
                 <Card>
                    <span style={{"float":"right"}}>
                         <IconButton aria-label="delete" onClick={() => {
                            setEditingScheduleObj({...schedules[i]});
                            setEditingScheduleObjIndex(i);
                        }}>
                          <EditIcon/>
                        </IconButton>
                        <IconButton aria-label="delete" onClick={() => {
                            console.log(indexCnt);
                            const supp = [...schedules];
                            supp.splice(indexCnt, 1);
                            props.setSchedules(supp)
                        }}>
                          <DeleteIcon/>
                        </IconButton>
                    </span>
                    <br/>
                  <CardContent>
                    <Typography  color="text.secondary" gutterBottom>
                      {schedules[i].days.join(",")}<br/>
                      From: {schedules[i].startDate.toLocaleString('en-US', dtFormat)}
                      <br/>To: {schedules[i].endDate.toLocaleString('en-US', dtFormat)}
                    </Typography>
                  </CardContent>
                </Card>
            </span>
           )
        scheduleElements.push(<br key={`br${i}of-schedule`}/>);
    }

    const [editingScheduleObj, setEditingScheduleObj] = useState(null);
    const [editingScheduleObjIndex, setEditingScheduleObjIndex] = useState(null);
    const doesOverlap = hoursOfDayOverlap(schedules);
    return <>
        <Typography align="left" variant={"h5"}>
            Add Schedule Constraints&nbsp;&nbsp;&nbsp;
            <IconButton aria-label="create" onClick={() => {
                // TODO Something Here
                props.setSchedules([...schedules, {
                    startDate: new Date(Date.now()),
                    endDate: new Date(Date.now() + 10000000),
                    days: ["mon","tues","wed","thurs","fri","sat","sun"]
                }])
                // props.setSuppressions([...suppressions, ""])
            }}>
                <AddCircleIcon color={"success"}/>
            </IconButton>
        </Typography>
        {doesOverlap && <Typography color={"error"} variant={"subtitle1"} style={{}}>RANGES OVER LAP</Typography>}
        <div style={{"marginLeft": "2em"}}>
            {scheduleElements}
        </div>

        <Modal
            open={editingScheduleObj != null}
            onClose={() => {
            }}
            aria-labelledby="test-modal"
            aria-describedby="test-modal-description"
            style={{"overflowY": "scroll"}}
        >

            <Box sx={{...modalStyle}}
                 style={{"maxHeight": "calc(100vh - 210px)", "overflowY": "auto"}}>
                {editingScheduleObj != null &&
                <>
                    <Typography align="left">
                        Schedule Time Range (Times Are In Eastern)
                    </Typography>
                    <br/>

                      <TimePicker
                        renderInput={(props) => <TextField {...props} />}
                        label="Start Time"
                        value={editingScheduleObj.startDate}
                        onChange={(newValue) => {
                            newValue.setFullYear(2,1,2);
                            console.log(newValue);
                            const n = {...editingScheduleObj, startDate: newValue};
                            // swapStartAndEnd(n);
                            setEditingScheduleObj(n)
                        }}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <TimePicker
                        renderInput={(props) => <TextField {...props} />}
                        label="End Time"
                        value={editingScheduleObj.endDate}
                        onChange={(newValue) => {
                            newValue.setFullYear(2,1,2);

                            const n = {...editingScheduleObj, endDate: newValue};
                            // swapStartAndEnd(n);
                            setEditingScheduleObj(n);
                        }}
                    />
                    <FormGroup>
                        {["mon","tues","wed","thurs","fri","sat","sun"].map((d)=>
                            <FormControlLabel control={
                          <Checkbox checked={editingScheduleObj.days.indexOf(d) !== -1}
                                    onChange={(e)=>{
                                        console.log(`CHANGE for ${d}`);
                                        console.log(e.target.checked);
                                        console.log(editingScheduleObj.days.indexOf(d));
                                        const lindex = editingScheduleObj.days.indexOf(d);
                                        if(e.target.checked){
                                            if( lindex=== -1){
                                                const n = {...editingScheduleObj, days: editingScheduleObj.days.concat(d)};
                                                setEditingScheduleObj(n)
                                            }
                                        }else if(lindex !== -1){
                                            const newList = [...editingScheduleObj.days];
                                            newList.splice(lindex, 1);
                                            const n = {...editingScheduleObj, days: newList};
                                            setEditingScheduleObj(n)
                                        }
                                    }
                          }/>} label={d.toUpperCase()} />
                        )}

                    </FormGroup>

                    <br/><br/>
                    <ButtonGroup disableElevation variant="contained" style={{"width": "100%"}}>
                        <Button size="Large" align="left" variant="contained" color="warning" onClick={() => {
                            setEditingScheduleObj(null);
                            setEditingScheduleObjIndex(null);
                        }} style={{"width": "50%"}}>
                            Cancel
                        </Button>
                        <Button size="Large" align="right" variant="contained" color="success" onClick={() => {
                            const supp = [...schedules];
                            supp[editingScheduleObjIndex] = editingScheduleObj;
                            props.setSchedules(supp)
                            setEditingScheduleObj(null);
                            setEditingScheduleObjIndex(null);
                        }} style={{"width": "50%"}}>
                            Save
                        </Button>
                    </ButtonGroup>
                </>
                }

            </Box>
        </Modal>

    </>
}


TimesOfDaySelector.propTypes = {
    schedules: PropTypes.array,
    setSchedules: PropTypes.func,
}